<template>
  <div class="modal fade" id="cuModal" tabindex="-1" role="dialog" aria-labelledby="cuModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="cuModalLabel">{{ modalContent.title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label" for="company_name">Company Name</label>
            <input class="form-control" id="company_name"
              :class="form.errors.has('company_name') ? 'is-invalid' : ''"
              v-model="form.company_name" @keydown="form.errors.clear('company_name')"
            >
            <div class="invalid-feedback"
              v-if="form.errors.has('company_name')"
              v-text="form.errors.get('company_name')"
            />
          </div>


          <div class="form-group">
            <label class="custom-label" for="adress">Adress</label>
            <input class="form-control" id="adress"
              :class="form.errors.has('adress') ? 'is-invalid' : ''"
              v-model="form.adress" @keydown="form.errors.clear('adress')"
            >
            <div class="invalid-feedback"
              v-if="form.errors.has('adress')"
              v-text="form.errors.get('adress')"
            />
          </div>

          <div class="form-group">
            <label class="custom-label" for="website">Website</label>
            <input class="form-control" id="website"
              :class="form.errors.has('website') ? 'is-invalid' : ''"
              v-model="form.website" @keydown="form.errors.clear('website')"
            >
            <div class="invalid-feedback"
              v-if="form.errors.has('website')"
              v-text="form.errors.get('website')"
            />
          </div>

          <div class="form-group">
            <label class="custom-label">General Manager</label>
            <div class="row">
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-user-tie"></i>
                    </span>
                  </div>
                  <input class="form-control" id="gm_name" placeholder="Name"
                    :class="form.errors.has('gm_name') ? 'is-invalid' : ''"
                    v-model="form.gm_name" @keydown="form.errors.clear('gm_name')"
                  >
                  <div class="invalid-feedback"
                    v-if="form.errors.has('gm_name')"
                    v-text="form.errors.get('gm_name')"
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-phone"></i>
                    </span>
                  </div>
                  <input class="form-control" id="gm_phone" placeholder="Phone Number"
                    :class="form.errors.has('gm_phone') ? 'is-invalid' : ''"
                    v-model="form.gm_phone" @keydown="form.errors.clear('gm_phone')"
                  >
                  <div class="invalid-feedback"
                    v-if="form.errors.has('gm_phone')"
                    v-text="form.errors.get('gm_phone')"
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-at"></i>
                    </span>
                  </div>
                  <input class="form-control" id="gm_email"
                    :class="form.errors.has('gm_email') ? 'is-invalid' : ''" placeholder="Email"
                    v-model="form.gm_email" @keydown="form.errors.clear('gm_email')"
                  >
                  <div class="invalid-feedback"
                    v-if="form.errors.has('gm_email')"
                    v-text="form.errors.get('gm_email')"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="custom-label">Marketing</label>
            <div class="row">
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-user-tie"></i>
                    </span>
                  </div>
                  <input class="form-control" id="marketing_name" placeholder="Name"
                    :class="form.errors.has('marketing_name') ? 'is-invalid' : ''"
                    v-model="form.marketing_name" @keydown="form.errors.marketing_name('marketing_name')"
                  >
                  <div class="invalid-feedback"
                    v-if="form.errors.has('marketing_name')"
                    v-text="form.errors.get('marketing_name')"
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-phone"></i>
                    </span>
                  </div>
                  <input class="form-control" id="marketing_phone" placeholder="Phone Number"
                    :class="form.errors.has('marketing_phone') ? 'is-invalid' : ''"
                    v-model="form.marketing_phone" @keydown="form.errors.marketing_phone('marketing_phone')"
                  >
                  <div class="invalid-feedback"
                    v-if="form.errors.has('marketing_phone')"
                    v-text="form.errors.get('marketing_phone')"
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-at"></i>
                    </span>
                  </div>
                  <input class="form-control" id="marketing_email" placeholder="Email"
                    :class="form.errors.has('marketing_email') ? 'is-invalid' : ''"
                    v-model="form.marketing_email" @keydown="form.errors.marketing_email('marketing_email')"
                  >
                  <div class="invalid-feedback"
                    v-if="form.errors.has('marketing_email')"
                    v-text="form.errors.get('marketing_email')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary"
            :disabled="form.isWorking()"
            @click="handleSubmit"
          >
            <span v-if="form.isWorking()">Checking Input...</span>
            <span v-else>{{ modalContent.submitText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import createUpdateMixin from './../cu-modal-mixin'

  export default {
    mixins: [createUpdateMixin],
    data() {
      return {
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/distributors/CuModal.vue